import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

interface Props {
  showButtonCloseCircle?: number
  onShowCloseCircle: () => void
  onScanPassport: () => void
}

export const Header: FC<Props> = ({
  showButtonCloseCircle = 0,
  onShowCloseCircle,
  onScanPassport,
}) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      {showButtonCloseCircle > 0 ? (
        <Button
          type="button"
          variant="opacityBlue"
          onClick={onShowCloseCircle}
          style={{ padding: '12px 0px', borderRadius: 12, width: '50%' }}
        >
          <span className={s.filledBtn}>
            <AppIcon
              id={AllIcons.PERSONS}
              className={s.icon}
              height={20}
              width={20}
            />

            <span className="semi-bold-14">{t('сlose_circlу')}</span>
          </span>
        </Button>
      ) : null}

      <Button
        type="button"
        variant="opacityBlue"
        onClick={onScanPassport}
        style={{ padding: '12px 0px', borderRadius: 12, width: '50%' }}
      >
        <span className={s.filledBtn}>
          <AppIcon
            id={AllIcons.PASSPORT_SCAN}
            className={s.icon}
            height={20}
            width={20}
          />
          <span className="semi-bold-14">
            {t('scan_passport.scan_passport')}
          </span>
        </span>
      </Button>
    </div>
  )
}
